export default {
  title: 'Ennakkotilaus',
  categories: {
    title: 'Suosituimmat',
  },
  header: {
    pickup: 'Nouto 5 minuutissa',
  },
};
